import { css, Theme } from '@emotion/react'
import { Box, Typography } from '@mui/material'

import { FlowBlock } from '~/components/atoms/FlowBlock'

type Props = {
  title: string
  subtitle: string
  colorProps: {
    color: string
    number: number
    flow: string
    title: string
    description: string
  }[]
}

const Solution: React.FC<Props> = ({ title, subtitle, colorProps }) => {
  return (
    <Box css={styles.wrapper} component='section' id='service' color='primary'>
      <Box css={styles.container}>
        <Box css={styles.head}>
          <Typography variant='h1' css={styles.title} color='primary'>
            {title}
          </Typography>
          <Typography variant='h2' css={styles.subtitle} color='primary'>
            {subtitle}
          </Typography>
        </Box>
        <Box css={styles.flow_container}>
          {colorProps.map(item => (
            <FlowBlock
              key={item.number}
              color={item.color}
              number={item.number}
              flow={item.flow}
              title={item.title}
              description={item.description}
            />
          ))}
        </Box>
      </Box>
    </Box>
  )
}

const styles = {
  wrapper: (theme: Theme) => css`
    width: 100vw;
  `,
  container: css`
    max-width: 1180px;
    margin: 0 auto;
  `,
  head: css`
    padding: 40px 60px;
    color: white;
    @media (max-width: 768px) {
      padding: 40px 20px;
    }
  `,
  title: css`
    font-family: 'Noto sans JP', sans-serif;
    font-size: 3rem;
    font-weight: 700;
    margin: 4rem 2rem 6rem;
    padding-left: 40px;
    border-left: 8px solid #0d9bbe;
    @media (max-width: 960px) {
      font-size: 2.1rem;
    }
    @media (max-width: 768px) {
      padding-left: 20px;
      margin: 0rem 0rem 2rem;
      font-size: 1.6rem;
    }
  `,
  subtitle: css`
    padding: 0 40px;
    line-height: 3rem;
    font-family: 'Noto Sans JP', sans-serif;
    font-size: 1rem;
    font-weight: 500;
    @media (max-width: 768px) {
      padding: 0 15px;
      margin-bottom: 1.5rem;
      line-height: 2rem;
      font-size: 0.8rem;
      font-weight: 500;
    }
  `,
  flow_container: css`
    padding: 0 40px 80px;
    @media (max-width: 768px) {
      padding: 0 0 80px;
    }
  `,
}

export default Solution
